__turbopack_context__.v({
  "article": "_RhhLa_article",
  "button": "_RhhLa_button",
  "image": "_RhhLa_image",
  "textContainer": "_RhhLa_textContainer",
  "title": "_RhhLa_title",
});
